import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Sidebar ({ collapsed, onToggle }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [expandedMenus, setExpandedMenus] = useState({
    content: false,
    settings: false,
    reports: false,
  });

  const toggleMenu = (menuKey) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey],
    }));
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const menuItems = [
    {
      id: "overview",
      label: "Overview",
      icon: "🏠",
      type: "single",
      path: "/dashboard",
    },
    {
      id: "categories",
      label: "Category Management",
      icon: "📂",
      type: "single",
      path: "/dashboard/categories",
    },
    {
      id: "products",
      label: "Product Management",
      icon: "📦",
      type: "single",
      path: "/dashboard/products",
    },
    // Example with group/submenu
    {
      id: "user",
      label: "User",
      icon: "📝",
      type: "single",
      path: "/dashboard/user",

      // children: [
      //   { id: "posts", label: "Posts", path: "/dashboard/posts" },
      //   { id: "pages", label: "Pages", path: "/dashboard/pages" },
      //   { id: "media", label: "Media Library", path: "/dashboard/media" },
      // ],
    },
    {
      id: "order",
      label: "Order",
      icon: "📈",
      type: "single",
      path: "/dashboard/orders",

    },
    // {
    //   id: "settings",
    //   label: "Settings",
    //   icon: "⚙️",
    //   type: "group",
    //   children: [
    //     { id: "general", label: "General", path: "/dashboard/settings/general" },
    //     { id: "security", label: "Security", path: "/dashboard/settings/security" },
    //     { id: "integrations", label: "Integrations", path: "/dashboard/settings/integrations" },
    //   ],
    // },
  ];

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      {/* Sidebar Header */}
      <div className="sidebar-header">
        <div className="brand">
          {!collapsed && <span className="app-brand-link d-flex align-items-center gap-2 text-decoration-none  p-3">
            <img src="/assets/img/Leapat_header_logo.png" height={60} width={140} alt="Logo" />
          </span>}
        </div>
        <button className="sidebar-toggle d-lg-none" onClick={onToggle}>
          ✕
        </button>
      </div>

      {/* Navigation Menu */}
      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.map((item) => (
            <li key={item.id} className="nav-item">
              {item.type === "single" ? (
                <button
                  className={`nav-link ${isActive(item.path) ? "active" : ""}`}
                  onClick={() => handleNavigation(item.path)}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {!collapsed && <span className="nav-text">{item.label}</span>}
                </button>
              ) : (
                <>
                  <button
                    className={`nav-link nav-group ${expandedMenus[item.id] ? "expanded" : ""}`}
                    onClick={() => toggleMenu(item.id)}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    {!collapsed && (
                      <>
                        <span className="nav-text">{item.label}</span>
                        <span className="nav-arrow">▼</span>
                      </>
                    )}
                  </button>
                  {expandedMenus[item.id] && !collapsed && (
                    <ul className="nav-submenu">
                      {item.children.map((child) => (
                        <li key={child.id}>
                          <button
                            className={`nav-sublink ${isActive(child.path) ? "active" : ""}`}
                            onClick={() => handleNavigation(child.path)}
                          >
                            {child.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              )}
            </li>
          ))}
        </ul>
      </nav>

      {/* Sidebar Footer */}
      {/* {!collapsed && (
        <div className="sidebar-footer">
          <div className="upgrade-card">
            <h6>Upgrade to Pro</h6>
            <p>Get access to premium features</p>
            <button className="btn btn-primary btn-sm">Upgrade</button>
          </div>
        </div>
      )} */}
    </div>
  );
}